import React, { Component } from "react";
import __ from "lodash";
import { URL_AKM, CONFIG_API_BE } from "../../../../../config";
import akmApi from "../../../../../apis/akmApi";
import eduprimeApi from "../../../../../apis/eduprimeApi";
import LoaderModal from "../../../../modal/LoaderModal";
import Loader from "../../../../Loader";
import { Form, Row, Col } from "react-bootstrap";
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import DropdownSekolah from "../../masterDropDown/DropdownSekolah";
import DropdownKota from "../../masterDropDown/DropdownKota";
import DropdownProvinsi from "../../masterDropDown/DropdownProvinsi";
import AutocompleteSearchDinas from "./components/AutocompleteSearchDinas";
import AutocompleteSearchProvince from "./components/AutocompleteSearchProvince";
import AutocompleteSearchCity from "./components/AutocompleteSearchCity";
import AutocompleteSearchSekolah from "./components/AutocompleteSearchSekolah";

class JadwalForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            isLoading: false,
            jadwal: {},
            profil: {},
            provinsi: [],
            kota: [],
            sekolah: [],
            scope: 1,
            idProvinsi: "",
            idKota: "",
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.setState({
            jadwal: this.props.jadwal,
        });
        if (this.props.jadwal.idSekolah != null) {
            this.setState({ scope: 2 });
            this.fetchProvinsi();
            this.getSekolahById(this.props.jadwal.idSekolah);
        }
    }

    getSekolahById = async (idSekolah) => {
        const response = await akmApi.get(URL_AKM.GET_SEKOLAH_BY_ID + idSekolah).catch(function (error) {
            alert(error);
        });
        if (response) {
            if (response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
                this.setState({
                    idProvinsi: response.data.data.idProvinsi,
                    idKota: response.data.data.idKabupatenKota,
                });
                this.fetchKota(response.data.data.idProvinsi);
                this.fetchSekolah(response.data.data.idKabupatenKota);
            } else {
                alert("Terjadi Kesalahan.. Pls refresh");
            }
        }
    };
    fetchProvinsi = async () => {
        this.setState({ isFetching: true });
        const response = await eduprimeApi.get(CONFIG_API_BE.API_GET_PROVINSI).catch(function (error) {
            alert(error);
        });
        if (response) {
            this.setState({ provinsi: response.data.list_provinsi, isFetching: false });
        }
    };
    fetchKota = async (idProvinsi) => {
        this.setState({ isFetching: true });
        const response = await eduprimeApi.get(CONFIG_API_BE.API_GET_KAB_KOTA + idProvinsi).catch(function (error) {
            alert(error);
        });
        if (response) {
            this.setState({ kota: response.data.list_kab_kota, isFetching: false });
        }
    };
    fetchSekolah = async (idKota) => {
        this.setState({ isFetching: true });
        const response = await eduprimeApi.get(CONFIG_API_BE.API_GET_SEKOLAH + idKota).catch(function (error) {
            alert(error);
        });
        if (response) {
            this.setState({ sekolah: response.data.list_sekolah, isFetching: false });
        }
    };

    changeJudul = (e) => {
        this.setState((prevState) => ({ jadwal: { ...prevState.jadwal, namaJadwal: e.target.value } }));
    };
    changeJadwalMulai = (date) => {
        this.setState((prevState) => ({
            jadwal: { ...prevState.jadwal, jadwalMulai: date },
        }));
    };
    changeJadwalSelesai = (date) => {
        this.setState((prevState) => ({
            jadwal: { ...prevState.jadwal, jadwalSelesai: date },
        }));
    };
    changeJadwalReport = (date) => {
        this.setState((prevState) => ({
            jadwal: { ...prevState.jadwal, jadwalReport: date, openReportDate: date },
        }));
    };

    handleSubmit(e) {
        e.preventDefault();

        const formdata = new FormData(e.target);

        // convert FormData to json object
        // SOURCE: https://stackoverflow.com/a/46774073
        const data = {};
        formdata.forEach(function (value, prop) {
            data[prop] = value;
        });

        const dataSend = {
            ["idJadwal"]: this.state.jadwal.idJadwalProfilCbt,
            ["idProfil"]: this.props.profil.idProfilCbt,
            ["namaJadwal"]: data.namaJadwal,
            ["jadwalMulai"]: data.jadwalMulai,
            ["jadwalSelesai"]: data.jadwalSelesai,
            ["jadwalReport"]: data.jadwalReport,
            ["tahunAjaran"]: this.state.jadwal.kodeTahunAjaran,
            ["idKelas"]: this.props.profil.idKelas,
            ["idAdmin"]: this.props.profil.idAdmin,
            ["idSekolah"]: this.state.jadwal.idSekolah,
            ["idDinas"]: this.state.jadwal.idDinas,
            ["jadwalParalel"]: [],
            ["jadwalSiswa"]: [],
        };

        this.props.submitJadwal(dataSend);
    }

    handleBack() {
        this.props.handleBack();
    }

    handleChangeScope = async (event) => {
        const value = event.target.value;
        this.setState({ scope: value });
        this.fetchProvinsi();
    };
    handleChangeProvinsi = async (value) => {
        // const value = event.target.value;
        console.log("====================================");
        console.log("provinsi", value);
        console.log("====================================");
        this.setState({ idProvinsi: value });
        this.fetchKota(value);
    };
    handleChangeKota = async (value) => {
        console.log("====================================");
        console.log("kota", value);
        console.log("====================================");
        // const value = event.target.value;
        this.setState({ idKota: value });
        this.fetchSekolah(value);
    };
    handleChangeSekolah = async (value) => {
        // const value = event.target.value;
        this.setState((prevState) => ({
            jadwal: { ...prevState.jadwal, idSekolah: value },
        }));
    };

    handleChangeDinas = async (value) => {
        this.setState((prevState) => ({
            jadwal: { ...prevState.jadwal, idDinas: value },
        }));
    };

    renderScope() {
        if (this.state.scope == 2) {
            return (
                <Row>
                    <Col>
                        <Form.Group controlId="scope">
                            <Form.Label>Provinsi : </Form.Label>
                            <AutocompleteSearchProvince handleChangeProvinsi={this.handleChangeProvinsi} />
                            {/* <select className="form-control" name="provinsi" id="provinsi" value={this.state.idProvinsi} onChange={this.handleChangeProvinsi}>
                                <option value="">Pilih Provinsi...</option>
                                <DropdownProvinsi provinsi={this.state.provinsi} />
                            </select> */}
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="scope">
                            <Form.Label>Kabupaten/Kota : </Form.Label>
                            <AutocompleteSearchCity handleChangeKota={this.handleChangeKota} idProvinsi={this.state.idProvinsi} />
                            {/* <select className="form-control" name="kota" id="kota" value={this.state.idKota} onChange={this.handleChangeKota}>
                                <option value="">Pilih Kabupaten/Kota...</option>
                                <DropdownKota kota={this.state.kota} />
                            </select> */}
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="scope">
                            <Form.Label>Sekolah : </Form.Label>
                            <AutocompleteSearchSekolah handleChangeSekolah={this.handleChangeSekolah} idKota={this.state.idKota} />
                            {/* <select className="form-control" name="sekolah" id="sekolah" value={this.state.jadwal.idSekolah} onChange={this.handleChangeSekolah}>
                                <option value="">Pilih Sekolah...</option>
                                <DropdownSekolah sekolah={this.state.sekolah} />
                            </select> */}
                        </Form.Group>
                    </Col>
                </Row>
            );
        } else if (this.state.scope == 3) {
            return (
                <Row>
                    <Col sm={4}>
                        <Form.Group controlId="scope">
                            <Form.Label>Dinas : </Form.Label>
                            <AutocompleteSearchDinas handleChangeDinas={this.handleChangeDinas} />
                            {/* <select className="form-control" name="dinas" id="dinas" value={this.state.scope} onChange={this.handleChangeProvinsi}>
                            <option value="">Pilih Dinas...</option>
                        </select>                         */}
                        </Form.Group>
                    </Col>
                </Row>
            );
        } else {
            return <Row></Row>;
        }
    }

    render() {
        const { jadwal, kelasParalel, jadwalSiswa } = this.state;
        let pageTitle;
        if (jadwal.idJadwalProfilCbt) {
            pageTitle = "Edit Jadwal";
        } else {
            pageTitle = "Add Jadwal";
        }
        return (
            <>
                <Row>
                    <Col>
                        <h4>
                            {pageTitle} : {this.props.profil.namaProfil}
                        </h4>
                    </Col>
                    <Col className="text-center">
                        <small>
                            Keterangan<i className="text-danger">*</i> : <br />
                            1. Jadwal Kelas untuk menjadwalkan 1 kelas paralel.
                            <br />
                            2. Jadwal Siswa untuk menjadwalkan sesuai siswa yang dipilih.
                        </small>
                    </Col>
                </Row>

                {this.state.isLoading ? (
                    <Loader />
                ) : (
                    <Form onSubmit={this.handleSubmit}>
                        <Col sm={6}>
                            <Form.Group controlId="judul">
                                <Form.Label>Nama Jadwal : </Form.Label>
                                <Form.Control type="text" name="namaJadwal" placeholder="Input Nama Jadwal..." defaultValue={jadwal.namaJadwalCbt} maxLength="100" required />
                            </Form.Group>
                        </Col>

                        <Col sm={12} style={{ marginTop: 20 }}>
                            <Form.Group>
                                <Row>
                                    <Col>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDateTimePicker name="jadwalMulai" value={jadwal.jadwalMulai} onChange={this.changeJadwalMulai} label="Jadwal Mulai" onError={console.log} ampm={false} format="dd-MM-yyyy HH:mm" required />
                                        </MuiPickersUtilsProvider>
                                    </Col>
                                    <Col>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDateTimePicker name="jadwalSelesai" value={jadwal.jadwalSelesai} onChange={this.changeJadwalSelesai} label="Jadwal Selesai" onError={console.log} ampm={false} format="dd-MM-yyyy HH:mm" required />
                                        </MuiPickersUtilsProvider>
                                    </Col>

                                    <Col>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDateTimePicker
                                                name="jadwalReport"
                                                value={jadwal.openReportDate}
                                                onChange={this.changeJadwalReport}
                                                label="Jadwal Report & Pembahasan"
                                                onError={console.log}
                                                ampm={false}
                                                minDate={jadwal.jadwalMulai}
                                                format="dd-MM-yyyy HH:mm"
                                                required
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Col>
                                </Row>
                            </Form.Group>
                        </Col>

                        <Col sm={4} style={{ marginTop: 20 }}>
                            <Form.Group controlId="scope">
                                <Form.Label>Scope Jadwal : </Form.Label>
                                <select className="form-control" name="scope" id="scope" value={this.state.scope} onChange={this.handleChangeScope}>
                                    <option value="1">ALL</option>
                                    <option value="2">Sekolah</option>
                                    <option value="3">Dinas</option>
                                </select>
                            </Form.Group>
                        </Col>

                        <Col sm={12}>{this.renderScope()}</Col>

                        <Col style={{ marginTop: 40 }}>
                            <button type="button" className="btn btn-danger" onClick={() => this.handleBack()}>
                                <ArrowBackIosIcon fontSize="small" />
                                Batal
                            </button>
                            <button type="submit" className="btn btn-primary pull-right">
                                Simpan
                            </button>
                        </Col>
                    </Form>
                )}
                <LoaderModal isFetching={this.state.isFetching} />
            </>
        );
    }
}

export default JadwalForm;
